//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Layer from '../x-dialog/layer'
import ClinicList from './clinicList.vue'
import Map from './map.vue'
import City from './city'

export default {
  data() {
    return {
      titleCenter:'附近 50km 门店',
      titleLeft:'附近',
      state:1,  // 组件状态 1门店列表 2城市列表 3地图

      city:{
        code:'',
        name:''
      }, // 选中的城市
      Ponit:{},
    }
  },
  props: {
    value: {//显示隐藏
      type: [Boolean], 
      default:true 
    },
    hostPonit: { //外部传入的门店位置
      type: [Object], 
      default:()=>{
        return {
            lng:'',
            lat:''
        } 
      }
    }
  },
  components: {
    Layer,
    ClinicList,
    Map,
    City
  },
  created () {
    if(this.hostPonit.lng){
      this.state = 3
      this.Ponit = this.hostPonit
      this.setState({
          titleCenter : '门店地图',
          titleLeft : '',
          state: 3,
      })
    }
  },
  mounted () {
    this.STATISTICS_CONFIG.insur_clinicsdetail_click();
  },
  methods: {
    close(){
      this.$emit('input', false)
    },
    // 设置组件模式
    setState(info){
      info.titleCenter ? this.titleCenter = info.titleCenter : ''; //标题区中间title
      this.titleLeft = info.titleLeft  //标题区左侧按钮
      info.state ? this.state = info.state : '' //组件模式
      info.city ? this.city = info.city :''; //选中的城市
      info.Ponit ? this.Ponit = info.Ponit:'' //选中的门店位置
      
    },
    // 点击左上角按钮
    leftClick(){
      if(this.state == 1){ 
        this.state = 2
      }else if(this.state == 2){
        this.state = 1
      }else if(this.state == 3){
        this.state = 1
      }
    }
  },
}
